import { useEffect, useState } from 'react';

/**
 * The subject + chapter currently chosen in the top bar.
 *
 * WebLayout persists the selection to localStorage in an effect, which can land
 * a tick AFTER a page mounts, so a page that reads it once would show "pick a
 * subject" even though one is selected. We therefore watch the two keys.
 */
const read = () => {
  try {
    return {
      subject: window.localStorage.getItem('gv_active_subject') || '',
      topic: window.localStorage.getItem('gv_active_topic') || '',
    };
  } catch { return { subject: '', topic: '' }; }
};

export function useActiveScope() {
  const [scope, setScope] = useState(read);

  useEffect(() => {
    const sync = () => setScope(prev => {
      const next = read();
      return next.subject === prev.subject && next.topic === prev.topic ? prev : next;
    });
    const id = setInterval(sync, 500);
    window.addEventListener('storage', sync);
    return () => { clearInterval(id); window.removeEventListener('storage', sync); };
  }, []);

  return scope;
}

export default useActiveScope;
